import { ReactElement } from 'react';
import { instalmentContactInfoDisplayObject, instalmentCompanyInfoDisplayObject } from '@services/FormFieldConfig';
import { useFormikContext } from 'formik';
import { ComapnyInformationAccessible, ContactInformationAccessible } from '@components/index';
import { iInstalmentFormValues } from '@services/InstalmentService';

function InstalmentStep12(): ReactElement {
  const currentSp = 'Select if you do not have an email address';
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { values }: { values: iInstalmentFormValues; touched: any } = useFormikContext();
  return (
    <>
      {values.isDebtorTypeIndividual
      && <ContactInformationAccessible displayObject={instalmentContactInfoDisplayObject} currentStep={currentSp} />}
      {values.isDebtorTypeCompany
      && <ComapnyInformationAccessible displayObject={instalmentCompanyInfoDisplayObject} currentStep={currentSp} />}
    </>
  );
}

export default InstalmentStep12;
